import React from "react";
import MultiMissionExplainerContent from "./MultiMissionExplainerContent";
import { Section } from "@jsluna/section";
import { Card } from "@jsluna/card";

export const MultiMissionFooter = () => (
  <Section
    style={{
      paddingBottom: "0px",
      flex: "1",
      display: "flex",
      flexDirection: "column",
      justifyContent: "flex-end",
    }}
  >
    <Card className="ln-u-text-align-center">
      <MultiMissionExplainerContent />
    </Card>
  </Section>
);
